import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import calendar from 'dayjs/plugin/calendar';
import { Customer } from '@sonar-software/sonar-core';
import dayjs from 'dayjs';
import { LockFilled } from '@ant-design/icons';
import React from 'react';
import { Tag } from 'antd';
import utc from 'dayjs/plugin/utc';

dayjs.extend(calendar);
dayjs.extend(utc);

export interface CustomerViewTitleProps {
	id?: string;
	customer?: Customer | null;
	shardName?: string;
}

export const CustomerViewTitle: React.FC<CustomerViewTitleProps> = (props) => {
	const { id, customer } = props;

	return customer ?
		<div>
			<div
				className='customer-view-title'
				id={ id }>
				<span className='h1'>{ customer.name }</span>
				<span className='customer-view-title-tag'>
					{
						customer.isLocked &&
							<Tag
								color='gold'
								icon={ <LockFilled /> }>
								{ ADMIN_DASHBOARD_COPY.LOCKED }
							</Tag>
					}
				</span>
			</div>
			<div className='text-14'>
				{ ADMIN_DASHBOARD_COPY.ENROLLED_ON(
					dayjs.utc(customer?.enrolled).local()
						.calendar()
				) }
			</div>
		</div> : null;
};

